// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"78eba88a","662":"9d065ee2","741":"78eba88a","794":"e2aadcce"}[chunkId] + ".chunk.css";
};